import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApButtonComponent } from '@ap/button';
import { ApContentPipe, ApContentComponent } from '@ap/content';
import { ApIconComponent } from '@ap/icon';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { ApLoggingModule } from '@ap/logging';
import { MijnLoginTemplateModule } from '@ap/mijn-template';
import { ApModalComponent } from '@ap/modal';
import { ApNotificationComponent } from '@ap/notification';
import { ApPersistenceModule } from '@ap/persistence';

import { LoginAccordionModule } from '../../klant/login/accordion/login-accordion.module';
import { SignModule } from '../../klant/login/sign/sign.module';

import { BrowserOutdatedModalModule } from './browser-outdated-modal/browser-outdated-modal.module';
import { LoginWrapperComponent } from './login.wrapper.component';

/**
 * @ngdoc module
 * @name LoginWrapperModule
 */
@NgModule({
    declarations: [LoginWrapperComponent],
    imports: [
        ApAnalyticsModule,
        ApButtonComponent,
        ApContentPipe,
        ApContentComponent,
        ApLoggingModule,
        ApModalComponent,
        ApNotificationComponent,
        ApIconComponent,
        ApPersistenceModule,
        BrowserOutdatedModalModule,
        CommonModule,
        LoginAccordionModule,
        MijnLoginTemplateModule,
        SessiebeheerModule,
        SignModule,
        ReactiveFormsModule
    ],
    exports: [LoginWrapperComponent]
})
export class LoginWrapperModule {}
